import * as React from "react";
const SvgUsers = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M42 34.354a4 4 0 1 1 0 5.292M45 51H33v-1a6 6 0 1 1 12 0zm0 0h6v-1a6 6 0 0 0-9-5.197M43 37a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
    />
  </svg>
);
export default SvgUsers;
